<div class="container">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h4>Site Inventory</h4>
    <button
      class="btn btn-sm btn-primary"
      (click)="downloadCSV()"
      [disabled]="!sites || sites.length === 0"
      title="Download CSV"
    >
      <fa-icon [icon]="icons.download"></fa-icon>
      Download CSV
    </button>
  </div>

  @for (site of sites; track site) {
    <table
      class="table table-sm table-striped table-bordered table-row-detail table-hover"
    >
      <thead class="table-dark">
        <tr>
          <th colspan="4">
            {{ site.Name }} &mdash; {{ site.Cameras.length }} Cameras
          </th>
        </tr>
        <tr>
          <th>Camera Name</th>
          <th>IP Address</th>
          <th>MAC Address</th>
          <th>Camera Model</th>
        </tr>
      </thead>
      <tbody>
        @for (camera of site.Cameras; track camera) {
          <tr>
            <td>{{ camera.Name }}</td>
            <td>{{ camera.IpAddress }}</td>
            <td>{{ camera.MacAddress }}</td>
            <td>{{ camera.Model }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
